import { memo, useContext } from "react";
import Button from "../../../../components/button/Button";
import { Context } from "../../LiveTvPage";
import { LockedSVG } from "@/src/components/svgIcons";
import "./CategoryItem.scss";
import MarqueeText from "@/src/components/marqueeText/MarqueeText";

const CategoryItem = ({
    isActive,
    index,
    style = {},
    onMouseEnter = () => { },
}) => {

    const {
        channelsContent,
        setCurrentSection,
        currentCategoryId,
        setCurrentCategoryId,
        setCurrentChannelsSection
    } = useContext(Context);

    const categoryId = channelsContent.categories_arr[index];

    const category = channelsContent.categories_obj[categoryId];

    const mouseEnter = () => {
        onMouseEnter(index);
        setCurrentSection("channelsSection");
    };

    const onClick = (e) => {

        e.stopPropagation();

        if (window.Android && e.duration && e.duration > 500 && window.showColorButtons) {
            window.showColorButtons();
        } else {

            if (categoryId != "search" && category.items.length == 0) return;

            setCurrentCategoryId(categoryId);
            setCurrentChannelsSection("channels");

            if (categoryId == "search") {
                setCurrentSection("searchSection");
            }

        }

    };

    return (
        <div className={"channel-category-parent"} style={style}>
            <Button
                className="category-item focus-item"
                isActive={isActive}
                onMouseEnter={mouseEnter}
                onClick={onClick}
                isSelected={currentCategoryId == categoryId}
                data={index}
            >
                <div className="name">
                    <MarqueeText isActive={isActive}>
                        {category?.name}
                    </MarqueeText>
                </div>
                <div className="count">{category?.items.length}</div>
                <div className="lock-icon">
                    {category?.isLocked ? <LockedSVG /> : null}
                </div>
            </Button>
        </div>
    )

}

export default memo(CategoryItem);